import { render, staticRenderFns } from "./UserAddPermission.vue?vue&type=template&id=2ac4acc1&"
import script from "./UserAddPermission.vue?vue&type=script&lang=js&"
export * from "./UserAddPermission.vue?vue&type=script&lang=js&"
import style0 from "./UserAddPermission.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports